module.exports = __webpack_public_path__ + "img/gaizhang.b02d9a85.jpg";